import {
  FETCH_INTEGRATIONS,
  FETCH_INTEGRATION,
  FETCH_AGENCY_INTEGRATION,
  FETCH_AGENCY_INTEGRATIONS,
  FETCH_AGENCY_INTEGRATIONS_BY_INTEGRATION_ID
} from '../actions/types'

const initialState = {
  integrations: {},
  integration: null,
  agencyIntegration: null,
  agencyIntegrations: {},
  agencyIntegrationsByIntegrationId: {},
  assignedPortals: []
}

export default (state = initialState, action) => {
  switch (action.type) {
    case FETCH_INTEGRATIONS:
      return {
        ...state,
        integrations: action.payload
      }
    case FETCH_INTEGRATION:
      return {
        ...state,
        integration: action.payload
      }
    case FETCH_AGENCY_INTEGRATION:
      return {
        ...state,
        agencyIntegration: action.payload
      }
    case FETCH_AGENCY_INTEGRATIONS:
      return {
        ...state,
        agencyIntegrations: action.payload
      }
    case FETCH_AGENCY_INTEGRATIONS_BY_INTEGRATION_ID:
      return {
        ...state,
        agencyIntegrationsByIntegrationId: action.payload
      }
    default:
      return state
  }
}
